/**
 * @generated SignedSource<<0107a00a0d77d5a3e0f1eba3d5666b19>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ProposalStatus = "ACTIVE" | "CANCELLED" | "DEFEATED" | "EXECUTED" | "EXPIRED" | "OBJECTION_PERIOD" | "PENDING" | "QUEUED" | "UPDATABLE" | "VETOED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProposalDetailPanelFragment$data = {
  readonly description: string;
  readonly number: string;
  readonly objectionPeriodEndsAt: number;
  readonly proposer: {
    readonly address: {
      readonly resolvedName: {
        readonly address: string;
        readonly " $fragmentSpreads": FragmentRefs<"NounResolvedLinkFragment">;
      };
    };
  };
  readonly signers: ReadonlyArray<{
    readonly address: {
      readonly resolvedName: {
        readonly address: string;
        readonly " $fragmentSpreads": FragmentRefs<"NounResolvedLinkFragment">;
      };
    };
  }>;
  readonly status: ProposalStatus;
  readonly title: string;
  readonly transactions: ReadonlyArray<{
    readonly calldata: any;
    readonly signature: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProposalTransactionDisplayFragment">;
  }>;
  readonly updateHistory: ReadonlyArray<{
    readonly timestamp: number;
  }>;
  readonly updatePeriodEndsAt: number;
  readonly voteEndsAt: number;
  readonly voteStartsAt: number;
  readonly " $fragmentSpreads": FragmentRefs<"UpdateHistoryDialogContentFragment">;
  readonly " $fragmentType": "ProposalDetailPanelFragment";
};
export type ProposalDetailPanelFragment$key = {
  readonly " $data"?: ProposalDetailPanelFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProposalDetailPanelFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Address",
    "kind": "LinkedField",
    "name": "address",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ResolvedName",
        "kind": "LinkedField",
        "name": "resolvedName",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NounResolvedLinkFragment"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "address",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProposalDetailPanelFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatePeriodEndsAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "objectionPeriodEndsAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "voteEndsAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "voteStartsAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProposalTransaction",
      "kind": "LinkedField",
      "name": "transactions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "signature",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "calldata",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProposalTransactionDisplayFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Delegate",
      "kind": "LinkedField",
      "name": "proposer",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Delegate",
      "kind": "LinkedField",
      "name": "signers",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProposalUpdate",
      "kind": "LinkedField",
      "name": "updateHistory",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timestamp",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UpdateHistoryDialogContentFragment"
    }
  ],
  "type": "OnChainProposal",
  "abstractKey": null
};
})();

(node as any).hash = "3d6a58e89cfee050a2ec8dcca9e590d0";

export default node;
